import React from 'react';
import BooleanRadioButtons from '../components/BooleanRadioButtons';
import Card from '../components/card';
import { LoanCard } from './card-lenses';

const HasAgent = ({ model, onChange, ...cardProps }) => (
  <Card title="Are you currently working with a real estate agent?" {...cardProps}>
    <BooleanRadioButtons
      name="hasAgent"
      value={model.get('hasAgent')}
      onChange={onChange.bind(null, 'hasAgent')}
    />
  </Card>
);

HasAgent.id = 'HasAgent';

HasAgent.completed = ({ model }) => model.get('hasAgent') != null;

export default LoanCard(HasAgent);



// WEBPACK FOOTER //
// ./src/cards/has-agent.js